import { render, staticRenderFns } from "./IndicatorsTable.vue?vue&type=template&id=7011645a&scoped=true"
import script from "./IndicatorsTable.vue?vue&type=script&lang=js"
export * from "./IndicatorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011645a",
  null
  
)

export default component.exports